import {
  convertCmToFeet,
  convertCmToInches,
  convertCmToYards,
  convertCmToMiles,
  convertCmToMeters,
  convertCmToKilometers
} from "./CentimeterConversion";
import {
  convertFeetToInches,
  convertFeetToYards,
  convertFeetToMiles,
  convertFeetToMeters,
  convertFeetToCM,
  convertFeetToKilometers
} from "./FeetConversion";
import {
  convertInchesToCM,
  convertInchesToFeet,
  convertInchesToYards,
  convertInchesToMiles,
  convertInchesToMeters,
  convertInchesToKilometers
} from "./InchesConversion";
import {
  convertYardsToFeet,
  convertYardsToInches,
  convertYardsToMiles,
  convertYardsToMeters,
  convertYardsToCM,
  convertYardsToKilometers
} from "./YardsConversion";
import {
  convertMilesToFeet,
  convertMilesToInches,
  convertMilesToYards,
  convertMilesToMeters,
  convertMilesToCM,
  convertMilesToKilometers
} from "./MilesConversion";
import {
  convertMeterToFeet,
  convertMeterToInches,
  convertMeterToYards,
  convertMeterToMiles,
  convertMeterToCM,
  convertMeterToKilometers
} from "./MetersConversion";
import {
  convertKilometersToFeet,
  convertKilometersToInches,
  convertKilometersToYards,
  convertKilometersToMiles,
  convertKilometersToCM,
  convertKilometersToMeters
} from "./KilometersConversion";

function getFinalCentimeterConversion(val, conType) {
  let result = "";
  if (conType === "cmtoft") {
    result = convertCmToFeet(parseFloat(val));
  } else if (conType === "cmtoin") {
    result = convertCmToInches(parseFloat(val));
  } else if (conType === "cmtoyd") {
    result = convertCmToYards(parseFloat(val));
  } else if (conType === "cmtomi") {
    result = convertCmToMiles(parseFloat(val));
  } else if (conType === "cmtom") {
    result = convertCmToMeters(parseFloat(val));
  } else if (conType === "cmtokl") {
    result = convertCmToKilometers(parseFloat(val));
  }
  return result;
}

function getFinalFeetConversion(val, conType) {
  let result = "";
  if (conType === "fttoin") {
    result = convertFeetToInches(parseFloat(val));
  } else if (conType === "fttoyd") {
    result = convertFeetToYards(parseFloat(val));
  } else if (conType === "fttomi") {
    result = convertFeetToMiles(parseFloat(val));
  } else if (conType === "fttom") {
    result = convertFeetToMeters(parseFloat(val));
  } else if (conType === "fttocm") {
    result = convertFeetToCM(parseFloat(val));
  } else if (conType === "fttokl") {
    result = convertFeetToKilometers(parseFloat(val));
  }
  return result;
}

function getFinalInchesConversion(val, conType) {
  let result = "";
  if (conType === "intocm") {
    result = convertInchesToCM(parseFloat(val));
  } else if (conType === "intoft") {
    result = convertInchesToFeet(parseFloat(val));
  } else if (conType === "intoyd") {
    result = convertInchesToYards(parseFloat(val));
  } else if (conType === "intomi") {
    result = convertInchesToMiles(parseFloat(val));
  } else if (conType === "intom") {
    result = convertInchesToMeters(parseFloat(val));
  } else if (conType === "intokl") {
    result = convertInchesToKilometers(parseFloat(val));
  }
  return result;
}

function getFinalKilometersConversion(val, conType) {
  let result = "";
  if (conType === "kltoft") {
    result = convertKilometersToFeet(parseFloat(val));
  } else if (conType === "kltoin") {
    result = convertKilometersToInches(parseFloat(val));
  } else if (conType === "kltoyd") {
    result = convertKilometersToYards(parseFloat(val));
  } else if (conType === "kltomi") {
    result = convertKilometersToMiles(parseFloat(val));
  } else if (conType === "kltocm") {
    result = convertKilometersToCM(parseFloat(val));
  } else if (conType === "kltom") {
    result = convertKilometersToMeters(parseFloat(val));
  }
  return result;
}

function getFinalMetersConversion(val, conType) {
  let result = "";
  if (conType === "mtoft") {
    result = convertMeterToFeet(parseFloat(val));
  } else if (conType === "mtoin") {
    result = convertMeterToInches(parseFloat(val));
  } else if (conType === "mtoyd") {
    result = convertMeterToYards(parseFloat(val));
  } else if (conType === "mtomi") {
    result = convertMeterToMiles(parseFloat(val));
  } else if (conType === "mtocm") {
    result = convertMeterToCM(parseFloat(val));
  } else if (conType === "mtokl") {
    result = convertMeterToKilometers(parseFloat(val));
  }
  return result;
}

function getFinalMilesConversion(val, conType) {
  let result = "";
  if (conType === "mitoft") {
    result = convertMilesToFeet(parseFloat(val));
  } else if (conType === "mitoin") {
    result = convertMilesToInches(parseFloat(val));
  } else if (conType === "mitoyd") {
    result = convertMilesToYards(parseFloat(val));
  } else if (conType === "mitom") {
    result = convertMilesToMeters(parseFloat(val));
  } else if (conType === "mitocm") {
    result = convertMilesToCM(parseFloat(val));
  } else if (conType === "mitokl") {
    result = convertMilesToKilometers(parseFloat(val));
  }
  return result;
}

function getFinalYardsConversion(val, conType) {
  let result = "";
  if (conType === "ydtoft") {
    result = convertYardsToFeet(parseFloat(val));
  } else if (conType === "ydtoin") {
    result = convertYardsToInches(parseFloat(val));
  } else if (conType === "ydtomi") {
    result = convertYardsToMiles(parseFloat(val));
  } else if (conType === "ydtom") {
    result = convertYardsToMeters(parseFloat(val));
  } else if (conType === "ydtocm") {
    result = convertYardsToCM(parseFloat(val));
  } else if (conType === "ydtokl") {
    result = convertYardsToKilometers(parseFloat(val));
  }

  return result;
}

export {
  getFinalCentimeterConversion,
  getFinalFeetConversion,
  getFinalInchesConversion,
  getFinalKilometersConversion,
  getFinalMetersConversion,
  getFinalMilesConversion,
  getFinalYardsConversion
};
